import { onLoad } from "@/utils/_"

const ID = "AW-17823885188/E2pGCKnetpccEITPi7NC"

function gtag_ (...args: unknown[]) {
  window.dataLayer?.push(...args)
}
function gtag (cb: (id: string, g: typeof gtag_) => void) {
  cb(ID, gtag_)
}

const plugin: NuxtPlugin = ({ isDev }, inject) => {
  if (!isDev)
    onLoad(() => {
      const script = document.createElement("script")
      script.src = `https://www.googletagmanager.com/gtag/js?id=${ID}`
      script.async = true
      document.body.appendChild(script)

      window.dataLayer = window.dataLayer || []

      gtag_("js", new Date())
      gtag_("config", ID)
    })
  inject("gtag", gtag)
}
export default plugin

declare global {
  interface Window {
    dataLayer?: unknown[]
  }
}

export type Gtag = typeof gtag
declare module "vue/types/vue" {
  interface Vue { $gtag: Gtag }
}
declare module "@nuxt/types" {
  interface NuxtAppOptions { $gtag: Gtag }
  interface Context { $gtag: Gtag }
}
declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> { $gtag: Gtag }
}
